import { Outlet } from "react-router-dom"; // Used for nested routes
import { NavBar } from "./NavBar";
import { FooterPart } from "./Footer";
import ScrollToTop from "./HomePage/ScrollToTop"; // Used to scroll to top on route change

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-[#fffbf5]">
      <NavBar />
      <main className="flex-grow pt-[4.5rem]">
        <ScrollToTop />

        <Outlet />
      </main>
      <FooterPart />
    </div>
  );
}
